var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modalScroll d-flex flex-column align-items-center",staticStyle:{"width":"auto","height":"auto"}},[_c('div',{staticClass:"p-1"},[_c('button',{staticClass:"btn btn-close mb-1 saj-subtitle",staticStyle:{"color":"white","background":"#ff0000"},attrs:{"aria-label":"Close modal"},on:{"click":function($event){_vm.downloadPerformancePDF(_vm.empData),
            _vm.clear(),
            _vm.getScore(
              _vm.empData.jd_kra_status,
              _vm.empData.performance_id,
              _vm.empData.user_id
            )}}},[_vm._v(" "+_vm._s(_vm.$t("Download PDF"))+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }